/* global google */

import { debounce } from 'throttle-debounce';
import getjs from 'get-js';
import pDefer from 'p-defer';
import delay from 'delay';

import map from 'lodash/map';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';

const GOOGLE_MAP_API_URL = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAj8mP8ZD_MpRolYOOPJ33vtUNkQqU3Pr0&callback=gmapCallback&v=weekly';
const mapDefer = pDefer();

const MAX_DEFAULT_ZOOM = 15;
const DEBOUNCE_INTERVAL = 150;

export async function loadMapLibrary() {
  if (!('google' in window)) {
    await getjs(GOOGLE_MAP_API_URL);
  }

  await mapDefer.promise;
  const { default: Mark } = await import('./mark');

  return { Mark };
}

window.gmapCallback = function() {
  mapDefer.resolve();
};

export async function buildMap({
  node,
  geo,
  marksData,
  leadProps,
  isAutoCenter = true,
  isAutoOpen = false,
  isVueDataFlow = false,
  isNoBalloon = false,
  callbacks = {
    boundsChange: (_visibleMarks, _removedMarks) => {},
    showBalloon: null,
    hideBalloon: null
  }
}) {
  const { Mark } = await loadMapLibrary();

  const gmap = new google.maps.Map(node, {
    center: { lat: geo.latitude, lng: geo.longitude },
    zoom: geo.zoom
  });
  gmap.destroy = () => gmap.unbindAll();

  // сортировка, чтобы маркеры, расположенные правее и ниже, отображались над
  // маркерами, расположенными левее и выше
  const marks = marksData
    |> sortBy(?, 'latitude', 'longitude')
    |> reverse(?)
    |> map(?, markData => (
      new Mark({
        markData,
        leadProps,
        gmap,
        isAutoOpen,
        isVueDataFlow,
        isNoBalloon,
        emitBalloonShow: isVueDataFlow && callbacks.showBalloon,
        emitBalloonHide: isVueDataFlow && callbacks.hideBalloon
      })
    ));

  if (isAutoCenter && marks.length) {
    fitMapToMarkers(gmap, marks);
  }

  google.maps.event.addListener(gmap, 'bounds_changed', debounce(DEBOUNCE_INTERVAL, () => (
    callbacks.boundsChange(
      marks.filter(mark => (
        gmap.getBounds().contains(mark.position)
      ))
    )
  )));

  return { map: gmap, marks, fitMapToMarkers };
}

const fitMapToMarkers = debounce(DEBOUNCE_INTERVAL, (gmap, marks) => {
  if (!marks.length) { return; }

  const bounds = new google.maps.LatLngBounds();

  marks.forEach(mark => bounds.extend(mark.marker.position));
  gmap.fitBounds(bounds);

  // https://stackoverflow.com/questions/2989858/google-maps-v3-enforcing-min-zoom-level-when-using-fitbounds
  google.maps.event.addListenerOnce(gmap, 'bounds_changed', function() {
    gmap.setZoom(Math.min(gmap.getZoom(), MAX_DEFAULT_ZOOM));
  });
});
